// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@src/@core/layouts/VerticalLayout'
import {getUserData} from '@src/utility/Utils'

// ** Menu Items Array
import navigation from '@src/navigation/vertical'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLayout } from '@src/utility/hooks/useLayout'

const VerticalLayout = props => {
  // const [menuData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   const userData = getUserData()
  //   if (userData === user){

  //   }
  //   if (userData === staff)
  //   navigation = navigation.filter(x => x)
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])


  const { navbarNavigation } = useLayout()
  const [navigationMenu, setNavigation] = useState(navigation)

  useEffect(() => {
      if (Array.isArray(navbarNavigation) && navbarNavigation.length > 0) {
        setNavigation(navbarNavigation)
      }
  }, [navbarNavigation])

  return (
    <Layout menuData={navigationMenu} {...props}>
      {props.children}
    </Layout>
  )
}

export default VerticalLayout
